import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LMDetailSectionBase } from './lm-detail-section-base';
import { LandmarkPanel } from '@form/lm-form.model';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMFormService } from '@form/services/lm-form.service';
import { LMFormManualRepService } from '@form/lm-form-manual-rep.service';
import { LMFieldOptionsToolbarService } from '@field/services';
import { Observable, Observer, of } from 'rxjs';
import { LMHtmlUrlDocComponent } from '@html/lm-html-url-doc.component';
import { LMListTransactionEvent } from './lm-list.component';
import { LMContextService } from '@services/lm-context.service';
import { AppConstants } from '@utils/app.constants';
import { LMRefreshRequest } from '@app/components';

@Component({
  selector: 'lm-detail-section-url',
  template: `
    <div *ngIf="activated" style="height:100%; margin-bottom: -20px;">
      <lm-html-url-doc #LMHtmlUrlDoc
          *ngIf="url"
          [isHtmlFragment]="true"
          parentContainerId="{{!testVersion1 ? panel.id : null}}"
          automationId="{{panel.automationId}}"
          [url]="url"
          [adjustFrameToWindow]="true"
          (htmlUrlDisplayed)="onHtmlUrlDisplayed($event)"
          (landmarkApiLoaded)="onLandmarkApiLoaded($event)"
          (landmarkCustomReady)="onLandmarkCustomReady($event)"
          (notifyUrlTransactionComplete)="onNotifyUrlTransactionComplete($event)"
      ></lm-html-url-doc>
    </div>
  `,
  providers: [ LMFormService, LMFormManualRepService, LMFieldOptionsToolbarService ]
})
export class LMDetailSectionUrlComponent implements LMDetailSectionBase, OnInit {
  @ViewChild('LMHtmlUrlDoc') htmlDocComponent: LMHtmlUrlDocComponent;

  // todo change this to be @Input() panel: LandmarkPanel; and call
  //  this.setUrl() in ngOnInit.
  //  The panel should be set before ngOnInit is called and should not
  //  change once the component is constructed.
  @Input() set panel(panel: LandmarkPanel) {
    this._panel = panel;
    this.setUrl();
  }
  get panel(): LandmarkPanel {
    return this._panel;
  }

  @Input() set fromDataView(fromDataView: LMDataView) {
    this._fromDataView = fromDataView;
    this.setUrl();
    if (this.htmlDocComponent) {
      this.htmlDocComponent.setDataView(this._fromDataView);
    }
  }

  @Input() needsReload: boolean;
  @Output() detailSectionDisplayed = new EventEmitter<any>();
  @Output() panelDataUpdated = new EventEmitter<any>();
  @Input() public activated: boolean;

  // todo: can remove once readOnly is placed into the formSpec on the server.
  public url: string = undefined;

  private _fromDataView: LMDataView = null;
  private _panel: LandmarkPanel = null;

  public testVersion1: boolean;
  type: string;

  constructor(
    private lmContextService: LMContextService,
    private lmFormatUtilService: LMFormatUtilService
  ) {}

  ngOnInit() {
    this.testVersion1 = this.lmContextService.testVersion() === AppConstants.TESTVERSION_V1;
  }

  setUrl() {
    if (!this._panel || !this._fromDataView) {
      return;
    }

    this.url = this.lmFormatUtilService.formatMessageRule(this._panel.url, this._fromDataView);
  }

  onLandmarkCustomReady(event: any) {
    if (!this.htmlDocComponent) {
      return;
    }

    this.htmlDocComponent.setDataView(this._fromDataView);
  }

  onLandmarkApiLoaded(event: any) {
  }

  onHtmlUrlDisplayed(event: any) {
    this.detailSectionDisplayed.emit(this);
  }

  onNotifyUrlTransactionComplete(event: LMListTransactionEvent) {
    this.panelDataUpdated.emit(event);
  }

  isModified(): boolean {
    return false;
  }

  saveDetailSectionState() {
    // noop
  }

  clearDetailSectionState() {
    // noop
  }

  save(callBack: Observer<boolean>) {
    // nothing to save
    callBack.next(true);
    callBack.complete();
  }


  refresh(request: LMRefreshRequest): Observable<boolean> {  // TODO: Implement Me! Landmark api method telling the content to refresh?
    return of(true);
  }
}
